import { notification } from 'antd';

notification.config({ placement: 'topRight' });

export const Notify = notification;
